<template>
  <div class="page-top-space"></div>
  <ProfessionalTable/>
</template>

<script>
    import ProfessionalTable from "@/accounting/components/tables/ProfessionalTable.vue";

    export default {
        name: 'ProfessionalListView',
        components: {
          ProfessionalTable
        }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  h1
    color: THEME_COLOR_PRIMARY
    span
      color: THEME_COLOR_PRIMARY_FADDED
</style>

<style lang="stylus">
  main
    align-content start
</style>